import { mixRGB } from './color-utils';

export function harvestCssVars(cssVars: string) {
	const regex = /\{(.+?)\}/;

	return regex.exec(cssVars.replace(/https:/g, 'https__COLON__'))[1] // 1 corresponds to the first match group
		.split(';')
		.slice(0, -1)
		.map(declaration => declaration.split(':').map(part => part.trim()))
		.reduce((map, [property, value]) => {
			map[property] = value.replace('https__COLON__', 'https:');
			return map;
		}, {});
}

let cachedStyles: CSSStyleDeclaration | null = null;
export function getCssVarValue (varName: string) {
	const rootStyles = cachedStyles ?? getComputedStyle(document.documentElement);
	cachedStyles = rootStyles;
	const value = rootStyles.getPropertyValue(varName).trim();

	const colorMix = value.replace(/\s+/g, '').match(/color-mix\(insrgb,rgb\((\d+),(\d+),(\d+)\)(\d+)%?,rgb\((\d+),(\d+),(\d+)\)\)/);
	// (ignoring whitespace) if color looks like -> color-mix(in srgb,rgb(r1,g1,b1) p%,rgb(r2,g2,b2)), we have to parse and mix it
	// done for org appearance
	if (!colorMix)
		return value;
	else {
		const [
			_, r1, g1, b1, // first color
			p, // percentage
			r2, g2, b2 // second color
		] = colorMix.map(Number);

		return mixRGB({ r: r1, g: g1, b: b1 }, { r: r2, g: g2, b: b2 }, p / 100);
	}
}

export function invalidateCache () {
	cachedStyles = null;
}